/**
 * Extracts usage data from a billing plan exception payload if it exists.
 * Accepts a generic payload shape so it can be used from both the Redux bridge
 * and the Zustand store without depending on Redux types.
 */
export const getBillingPlanErrorUsage = (
  payload: unknown,
):
  | {
      maximum: number;
      current: number;
    }
  | undefined => {
  if (typeof payload !== "object" || payload === null) {
    return undefined;
  }

  // Legacy cast - may or may not be necessary
  // eslint-disable-next-line replo/no-as-cast
  const payloadRecord = payload as Record<string, unknown>;

  const usage =
    extractUsage(payloadRecord.response) ??
    extractUsage(payloadRecord.data) ??
    extractNestedUsage(payloadRecord);

  if (
    usage != null &&
    typeof usage === "object" &&
    "current" in usage &&
    // Legacy cast - may or may not be necessary
    // eslint-disable-next-line replo/no-as-cast
    typeof (usage as Record<string, unknown>).current === "number"
  ) {
    // Legacy cast - may or may not be necessary
    // eslint-disable-next-line replo/no-as-cast
    const usageData = usage as { current: number; maximum?: number };
    return {
      maximum: usageData.maximum ?? Number.POSITIVE_INFINITY,
      current: usageData.current,
    };
  }

  return undefined;
};

function extractUsage(value: unknown): unknown {
  if (typeof value !== "object" || value === null) {
    return undefined;
  }
  // Legacy cast - may or may not be necessary
  // eslint-disable-next-line replo/no-as-cast
  return (value as Record<string, unknown>).usage;
}

function extractNestedUsage(value: Record<string, unknown>): unknown {
  const details = value.details;
  if (typeof details !== "object" || details === null) {
    return undefined;
  }
  // Legacy cast - may or may not be necessary
  // eslint-disable-next-line replo/no-as-cast
  const errorDetails = (details as Record<string, unknown>).errorDetails;
  if (typeof errorDetails !== "object" || errorDetails === null) {
    return undefined;
  }
  // Legacy cast - may or may not be necessary
  // eslint-disable-next-line replo/no-as-cast
  return (errorDetails as Record<string, unknown>).usage;
}
